module.exports = __webpack_public_path__ + "static/img/15.e72a6a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/sp/15.png
// module id = AhVU
// module chunks = 0